import { createModel, RematchDispatch } from '@rematch/core';
import { produce } from 'immer';

import baseEntity from './base.entity';
import { storeName as childItemEntityStore } from './projectChildItem.entity';
import { RootModel } from '../models';
import { storeName as layoutModelStore } from '../models/layout.model';
import { FloorTypes, SimplifiedFloorTypes, SimplifiedProjectChildItemTypes } from '../../types';
import { convertFloorResponse, convertSimplifiedFloorResponse } from '../../utils';
import { getFloorById, getFloorByIds } from '../../services/floor.service';
import { FloorResponseTypes } from '../../types/response/floor';

export const storeName = 'floorEntity';

export const floorEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
    saves: produce((state, entities: FloorTypes[]) => {
      (entities || []).forEach((entity: FloorTypes) => {
        state.ids[entity.id] = entity;
      });
    }),
  },
  effects: (dispatch: RematchDispatch<typeof floorEntity>) => ({
    async findByIds(payload: number[], state: RootModel) {
      const { locale } = state[layoutModelStore];

      const entities: FloorTypes[] = state[storeName].ids;
      const savedItems: FloorTypes[] = [];
      const ids: number[] = [];
      payload.forEach((id) => {
        const item = entities[id];
        if (item && !item.isSimplified) {
          savedItems.push(item);
        } else {
          ids.push(id);
        }
      });

      if (!ids.length) return savedItems;
      const resp: FloorResponseTypes[] = await getFloorByIds(ids, locale.apiLanguage);
      const newItems: SimplifiedFloorTypes[] = resp.map((i) => convertSimplifiedFloorResponse(i));
      this.saves(newItems);
      return [...savedItems, ...newItems];
    },
    async findById(payload: number, state: RootModel) {
      const { locale } = state[layoutModelStore];
      const entities: FloorTypes[] = state[storeName].ids;
      const item = entities[payload];
      if (item && !item.isSimplified) return item;

      const childItems: SimplifiedProjectChildItemTypes[] = [];
      const data: FloorResponseTypes = await getFloorById(payload, locale.apiLanguage);
      const newItem: FloorTypes = convertFloorResponse(data);
      const { items = [] } = newItem;
      childItems.push(...items);
      dispatch[childItemEntityStore].saveSimplified(childItems);
      this.saves([newItem]);

      return newItem;
    },
    storeProjectItemTemp(payload: FloorResponseTypes) {
      const floor: FloorTypes = convertFloorResponse(payload);
      this.saves([floor]);

      return floor;
    },
  }),
});

export default floorEntity;
